var _circle, _circle2, _g, _circle3, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMercury(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 290,
    height: 290,
    viewBox: "0 0 290 290",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 145,
    cy: 145,
    r: 145,
    fill: "#DEF4FC"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_0_12771",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 290,
    height: 290
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 145,
    cy: 145,
    r: 145,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_0_12771)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M257 25C257 18.3726 251.627 13 245 13H187C180.373 13 175 18.3726 175 25C175 31.6274 180.373 37 187 37H245C251.627 37 257 31.6274 257 25ZM73 133C79.6274 133 85 138.373 85 145C85 151.627 79.6274 157 73 157H70C63.3726 157 58 162.373 58 169C58 175.627 63.3726 181 70 181H194C200.627 181 206 175.627 206 169C206 162.373 200.627 157 194 157H142L141.999 156.99C135.604 156.727 130.5 151.46 130.5 145C130.5 138.54 135.604 133.273 141.999 133.01L142 133H144C150.627 133 156 127.627 156 121C156 114.373 150.627 109 144 109H99L99.0004 108.99C92.6047 108.728 87.5 103.46 87.5 97C87.5 90.5399 92.6047 85.2721 99.0004 85.0102L99 85H119C125.627 85 131 79.6274 131 73C131 66.3726 125.627 61 119 61H46C39.3726 61 34 66.3726 34 73C34 79.6274 39.3726 85 46 85H51C57.6274 85 63 90.3726 63 97C63 103.627 57.6274 109 51 109H2C-4.62742 109 -10 114.373 -10 121C-10 127.627 -4.62742 133 2 133H73ZM130 205C136.627 205 142 210.373 142 217C142 223.627 136.627 229 130 229C123.373 229 118 223.627 118 217C118 210.373 123.373 205 130 205ZM252 217C252 210.373 246.627 205 240 205H178C171.373 205 166 210.373 166 217C166 223.627 171.373 229 178 229H240C246.627 229 252 223.627 252 217ZM166 265C166 258.373 160.627 253 154 253H134C127.373 253 122 258.373 122 265C122 271.627 127.373 277 134 277H154C160.627 277 166 271.627 166 265ZM245 157C251.627 157 257 162.373 257 169C257 175.627 251.627 181 245 181C238.373 181 233 175.627 233 169C233 162.373 238.373 157 245 157ZM34 169C34 162.373 28.6274 157 22 157H2C-4.62742 157 -10 162.373 -10 169C-10 175.627 -4.62742 181 2 181H22C28.6274 181 34 175.627 34 169ZM221 61C227.627 61 233 66.3726 233 73C233 79.6274 227.627 85 221 85H201C194.373 85 189 79.6274 189 73C189 66.3726 194.373 61 201 61H221Z",
    fill: "#B1D5E2"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_0_12771",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 290,
    height: 290
  }, _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 145,
    cy: 145,
    r: 145,
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_0_12771)"
  }, /*#__PURE__*/React.createElement("rect", {
    opacity: 0.0775757,
    x: 146,
    width: 145,
    height: 290,
    fill: "black"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMercury);
export default __webpack_public_path__ + "static/media/Mercury.577be94ed88bfe7e5f9e2a204b67f1ca.svg";
export { ForwardRef as ReactComponent };